import { render, staticRenderFns } from "./CmaFieldRow.vue?vue&type=template&id=2ed16e9c&scoped=true&"
import script from "./CmaFieldRow.vue?vue&type=script&lang=js&"
export * from "./CmaFieldRow.vue?vue&type=script&lang=js&"
import style0 from "./CmaFieldRow.vue?vue&type=style&index=0&id=2ed16e9c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed16e9c",
  null
  
)

export default component.exports